/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { About, ConsentPage, NoticePage, HelpPage, SelectPage } from 'ui/pages';
import { RouteProps, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Selectors, ActionCreators, Status } from 'store/ducks/startUp';
import { Ducks } from '@wit/vtv-x-foundation-lib';
import { PublicRoutePath, StartUpRoutePath } from './paths';
import AnimatedRoute from './AnimatedRoute';

type PublicRouteProps = RouteProps &
  React.Attributes & {
    path: PublicRoutePath;
    children: JSX.Element;
  };

function PublicRoute({ path, children, key, exact = false }: PublicRouteProps): JSX.Element {
  const startUpStatus = useSelector(Selectors.status);
  const isUserAuthenticated = useSelector(Ducks.Credentials.Selectors.isAuthenticated);
  const history = useHistory();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!startUpStatus) {
      dispatch(ActionCreators.init());
    } else if (
      (startUpStatus === Status.SUCCESS || startUpStatus === Status.WAITING_UI_USER_SWITCHING) &&
      !isUserAuthenticated
    ) {
      // user logged out, redirect to login page
      history.replace(StartUpRoutePath.SIGNIN_SINGNUP);
    }
  }, [dispatch, history, isUserAuthenticated, startUpStatus]);

  return (
    <AnimatedRoute
      path={path}
      key={key}
      exact={exact}
      render={() => {
        return children;
      }}
    />
  );
}

export default function PublicRoutes(): JSX.Element[] {
  return [
    <PublicRoute exact path={PublicRoutePath.ABOUT} key={PublicRoutePath.ABOUT}>
      {/* The page component goes here */}
      <p>ABOUT</p>
    </PublicRoute>,
    <PublicRoute path={PublicRoutePath.ABOUT_ELEMENT} key={PublicRoutePath.ABOUT_ELEMENT}>
      <About />
    </PublicRoute>,
    <PublicRoute path={PublicRoutePath.PRIVACY} exact key={PublicRoutePath.PRIVACY}>
      <SelectPage />
    </PublicRoute>,
    <PublicRoute path={PublicRoutePath.PRIVACY_NOTICE} key={PublicRoutePath.PRIVACY_NOTICE}>
      <NoticePage />
    </PublicRoute>,
    <PublicRoute path={PublicRoutePath.PRIVACY_CONSENT} key={PublicRoutePath.PRIVACY_CONSENT}>
      <ConsentPage />
    </PublicRoute>,
    <PublicRoute path={PublicRoutePath.HELP} key={PublicRoutePath.HELP}>
      <HelpPage />
    </PublicRoute>,
    <PublicRoute path={PublicRoutePath.ERROR} key={PublicRoutePath.ERROR}>
      {/* The page component goes here */}
      <p>ERROR</p>
    </PublicRoute>,
  ];
}
